import * as React from 'react';
import { IData } from '../virtual-data/VirtualData';
import { FinalTableComputedColumn, FinalTableProps } from './FinalTableProps';
import { GridCellProps } from 'react-virtualized/dist/es/Grid';
import { ReactNode } from 'react';
import { HeaderCell } from './HeaderCell';
import { TableRowsHeights } from './utils';

type Props<DATA extends IData<ID>, FILTER, ID> = {
  finalTableProps: FinalTableProps<DATA, FILTER, ID>;
  formattedColumns: FinalTableComputedColumn<DATA>[];
  columnResizingIndex?: number;
  heights: TableRowsHeights;
  gridCellProps: GridCellProps;
  columnsWidth: { [key: number]: number };
  noVerticalScroll: boolean;
  setColumnResize: (
    finalTableProps: FinalTableProps<DATA, FILTER, ID>,
    formattedColumns: FinalTableComputedColumn<DATA>[],
    position: number,
    identifikator: string,
    widths: { [key: number]: number }
  ) => void;
};

export const HeaderRow = <DATA extends IData<ID>, FILTER, ID>({
  finalTableProps,
  formattedColumns,
  gridCellProps,
  heights,
  noVerticalScroll,
  columnsWidth,
  setColumnResize,
  columnResizingIndex,
}: Props<DATA, FILTER, ID>) => {
  const cells: ReactNode[] = [];

  const colCount = noVerticalScroll
    ? formattedColumns.length
    : formattedColumns.length + 1;
  let x = 0;
  for (let colIndex = 0; colIndex < colCount; colIndex++) {
    const cellStyle: React.CSSProperties = {
      position: 'absolute',
      height: heights.headerHeight,
      width: columnsWidth[colIndex],
      left: x,
      top: 0,
    };
    x += columnsWidth[colIndex];

    cells.push(
      <HeaderCell
        key={`${colIndex}-${gridCellProps.key}`}
        finalTableProps={finalTableProps}
        formattedColumns={formattedColumns}
        columnResizing={columnResizingIndex === colIndex}
        gridCellProps={{
          rowIndex: gridCellProps.rowIndex,
          columnIndex: colIndex,
          key: `${gridCellProps.key}_${gridCellProps.rowIndex}_${colIndex}`,
          isScrolling: false,
          isVisible: true,
          parent: gridCellProps.parent,
          style: cellStyle,
        }}
        setColumnResize={setColumnResize}
        columnsWidth={columnsWidth}
      />
    );
  }

  return <>{cells}</>;
};
